import { BlogSection } from '@/types/blog';

export const visualisierenSection: BlogSection = {
  id: 'visualisieren',
  title: 'Finanzielle Entscheidungen visualisieren',
  content: `
    <h3>4. Finanzielle Entscheidungen visualisieren</h3>
    
    <p>
      Gehirnscans zeigen: Wenn Menschen sich ihre finanziellen Ziele konkret vorstellen, werden die gleichen 
      neuronalen Netzwerke aktiviert wie bei echten Erfahrungen (Sharot et al., 2007). Visualisiere also nicht 
      nur abstrakte Sparziele, sondern stelle dir genau vor, wie dein zukünftiges Leben mit mehr finanzieller 
      Freiheit aussieht.
    </p>
    
    <div class="my-6 bg-joerg-50 p-5 rounded-lg border border-joerg-100">
      <h4 class="text-joerg-800 font-medium mb-3">Visualisierungsübung für finanzielle Ziele:</h4>
      <ol class="list-decimal pl-5">
        <li class="mb-2">Nimm dir 10 Minuten in einer ruhigen Umgebung</li>
        <li class="mb-2">Schließe die Augen und stelle dir vor, wie dein Leben in 5 Jahren aussieht, wenn du deine finanziellen Ziele erreicht hast</li>
        <li class="mb-2">Was siehst du? Wo lebst du? Was machst du beruflich? Wie gehst du mit Geld um?</li>
        <li class="mb-2">Welche Emotionen empfindest du in dieser Zukunftsvision?</li>
        <li>Notiere anschließend, was du gesehen und gefühlt hast</li>
      </ol>
    </div>
    
    <p>
      Wiederhole diese Übung regelmäßig und passe deine Vision an, wenn sich deine Ziele ändern. 
      Die emotionale Verbindung zu deinen Zielen wird dich motivieren, die nötigen Schritte zu unternehmen.
    </p>
  `
};